{
  "longPressMessage": "Náhľad otvoríte dlhým stlačením"
}
